const keyNumbers = {
  init() {

    // config
    this.config = {
      autoHeight: true
    } ;


    if (document.querySelector(".block-keynumbers")) {
      const $keyNumberBox = document.querySelector(
        ".block-keynumbers .keyNumbersBox"
      );
      const $keyNumbers = $keyNumberBox.querySelectorAll("li");
      const $btnPrev = document.querySelector(
        ".block-keynumbers #keyNumbers-prev"
      );
      const $btnNext = document.querySelector(
        ".block-keynumbers #keyNumbers-next"
      );
      this.index = 1;
      // this.height = $keyNumberBox.querySelector(`li:nth-child(${this.index})`);

      $btnPrev.addEventListener("click", () => {
        this.goPrev($keyNumberBox, $keyNumbers.length);
      });
      $btnNext.addEventListener("click", () => {
        this.goNext($keyNumberBox, $keyNumbers.length);
      });
      if (window.innerWidth <= 768) {
        if(this.config.autoHeight) {
          $keyNumberBox.style.width = '100%';
          $keyNumberBox.dataset.autoHeight = 'true'
         
        }else{
          $keyNumberBox.style.width = `${$keyNumbers.length * 100}%`
        }  

       
      } else {
        $keyNumberBox.style.width = "auto";
      }

      


    }
  },
  goPrev(keyNumberBox, length) {
    const removedElt =
      keyNumberBox.children[keyNumberBox.querySelectorAll("li").length - 1];
    keyNumberBox.removeChild(removedElt);
    keyNumberBox.prepend(removedElt);
    

    if (this.index <= 1) {
      this.index = length;
    } else {
      this.index--;
    }

    this.stylylizeDot();
  },
  goNext(keyNumberBox, length) {
    const removedElt = keyNumberBox.children[0];
    keyNumberBox.removeChild(removedElt);
    keyNumberBox.appendChild(removedElt);
    if (this.index >= length) {
      this.index = 1;
    } else {
      this.index++;
    }
    this.stylylizeDot();
  },
  stylylizeDot() {
    const $dots = document.querySelectorAll(".block-keynumbers .dots .dot");
    $dots.forEach(dot => {
      dot.style.background = "#fff";
    });
    $dots[this.index - 1].style.background = "#ed3680";

  }, 
  resizeSlider(slider) {
    // this.height = document.querySelector(`.block-keynumbers .keyNumbersBox li:first-child`).clientHeight;
    // document.querySelector(`.block-keynumbers .keyNumbersBox li:not(:first-child)`).style.height = this.height + 'px'
  }

};

export default keyNumbers;
